import React from "react";
import Proptypes from "prop-types";
import Modal from "../Modal/Modal";
import HubspotForm from "react-hubspot-form";
import $ from "jquery";
// import axios from "axios";

//for huspot form submit :(
window.jQuery = $;
window.$ = $;
global.jQuery = $;

class MagazineGate extends React.Component {
    static defaultProps = {
        text: "",
        classes: "",
        glyph: "",
        redirectUrl: "",
        sitename: ""
    };

    static propTypes = {
        text: Proptypes.string,
        classes: Proptypes.string,
        glyph: Proptypes.string,
        redirectUrl: Proptypes.string,
        sitename: Proptypes.string
    };

    state = {
        open: false,
        hutk: "",
        hubspotEmail: "",
        error: ""
    };

    checkGatedAccess = () => {
        let email = this.getCookieValue("hubspotemail");
        if(email) {
            this.setState({
                hubspotEmail: email
            });
            window.open(this.props.redirectUrl, "_blank");
        } else {
            if(this.state.open) {
                this.closeModal();
            } else {
                this.openModal();
            }
        }
    }

    closeModal = () => {
        this.setState({
            open: false,
            error: ""
        });
    }

    openModal = () => {
        this.setState({
            open: true,
            error: ""
        });
    }

    componentDidMount() {
        let hutk = this.getCookieValue("hubspotutk");
        let hubspotEmail = this.getCookieValue("hubspotemail");

        this.setState({
            hutk,
            hubspotEmail
        });
    }

    getGlyph = () => {
        if(this.props.glyph) {
            return <i className={this.props.glyph} aria-hidden="true" />;
        }
    }

    getCookieValue = (name) => {
        let cookie = document.cookie;
        let cookies = cookie.replace(/\s/g, "").split(";");
        let value = "";

        for(let i = 0; i<cookies.length; i++) {
            if(cookies[i].indexOf(`${name}=`) != -1) {
                value = cookies[i].replace(`${name}=`, "");
            }
        }

        return value;
    }

    setCookie = (cname, cvalue, exdays) => {
        var d = new Date();
        d.setTime(d.getTime() + (exdays*24*60*60*1000));
        var expires = "expires="+ d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    }

    onSubmit = (fields) => {
        if(fields.length && fields.length > 1) {
            fields.pop(); //get rid of last one for the download button
            // let data = {
            //     fields: fields
            // };

            let email = "";

            for(let i = 0; i<fields.length; i++) {
                if(fields[i].name == "email") {
                    email = fields[i].value;
                    break;
                }
            }

            // if(this.state.hutk) {
            //     data.context = {
            //         "hutk": this.state.hutk, // include this parameter and set it to the hubspotutk cookie value to enable cookie tracking on your submission
            //         "pageUri": "https://www.labmanager.com/magazine",
            //         "pageName": "Magazine Issues | Lab Manager"
            //     };
            // }
            // axios.post("https://api.hsforms.com/submissions/v3/integration/submit/547446/12afb868-cf57-4465-89ab-667aa7511da7", data).then(() => {
            //this.toggleModal();
            window.open(this.props.redirectUrl, "_blank");

            this.setCookie("hubspotemail", email, 395);
            this.setState({
                hubspotEmail: email
            });
            // }).catch(() => {
            //     let errorMsg = `Sorry, an error occured processing your request.`;

            //     this.setState({
            //         error: errorMsg
            //     });
            // });
        } else {
            // we should display an error message and not redirect
            this.setState({
                error: "Please complete the required fields."
            });
        }
    }

    render() {
        let classes = "magazine-gate-content";
        if(this.state.error) {
            classes += " showing-error";
        }
        return (
            <div>
                {this.state.open && <Modal>
                    <div className="magazine-gate-modal">
                        <div className={classes}>
                            <div className="close-btn" onClick={this.closeModal}>X</div>
                            <HubspotForm
                                portalId="547446"
                                formId="e63f8f80-59ed-47b5-b18a-aa726dea6baf"
                                onSubmit={this.onSubmit}
                            />
                            {this.state.error && <div className="invalid-feedback">
                                {this.state.error}
                            </div>}
                        </div>
                    </div>
                </Modal>}
                <button className={this.props.classes} onClick={this.checkGatedAccess}>
                    {this.getGlyph()}
                    {this.props.text}
                </button>
            </div>
        );
    }
}

export default MagazineGate;
